import DashboardLayout from '../components/DashboardLayout';

import PrintDataList from '../components/PrintDataList';
import TaskQueueModal from '../components/TaskQueueModal'

export default function GcodeListPage(){
    return (
      <DashboardLayout>
        <div>
          <TaskQueueModal
          ></TaskQueueModal>
          <PrintDataList></PrintDataList> 
        </div>
      </DashboardLayout>

    )
}